<template lang="pug">
md-layout
  .md-headline Preview
  // Video
  md-layout(md-flex='100')
    md-layout.video-frame(md-flex='80')
      div.rhebus-video-player(:id="contentDistributionId", :data-distribution-id="distributionId", :data-width="playerWidth", :data-height="playerHeight")
  md-layout(md-flex='100')
    span.md-caption Please note that feeds are cached for up to 1 minute, so changes may not immediately reflect in the player.
  md-layout#code-examples(md-flex='100')
    md-layout(md-flex='100')
      md-radio(v-for="config in codeConfigActives", :key="config.key", v-model='codeSample', :md-value='config.type') {{ config.radioLabel || config.type.charAt(0).toUpperCase() + config.type.slice(1) }}

    transition-group(
      name='fade',
      enter-active-class='animated fadeIn',
      enter-leave-class='animated fadeOut',
      mode='out-in'
    )
    template(v-for="config in codeConfigs")
      .code-block(v-show="codeSample === config.type", :key="config.key")
        template(v-if="config.blocks")
          template(v-for="block in config.blocks")
            .link-wrapper
              span.code-label {{ block.label }}
              md-button.copy.md-icon-button.md-primary(v-clipboard="block.getCode()", @success="copiedToClipBoard")
                md-icon(md-iconset="fa fa-clone")
              pre
                code {{ block.getCode() }}
        template(v-else)
          .link-wrapper
            span.code-label {{ config.label }}
            md-button.copy.md-icon-button.md-primary(v-clipboard="config.getCode()", @success="copiedToClipBoard")
              md-icon(md-iconset="fa fa-clone")
            pre
              code {{ config.getCode() }}


</template>

<script>
export default {
  data() {
    return {
      playerBase: process.env.PLAYER_URI,
      feedBase: process.env.FEED_URI,
      codeSample: "roku",
      codeConfigs: [
        {
          type: "roku",
          key: "rokuCode",
          active: true,
          getCode: () => `${this.feedUrl}/roku`,
          label: "Feed URL",
          radioLabel: "Roku",
        },
        {
          type: "mrss",
          key: "mrssCode",
          active: true,
          getCode: () => `${this.feedUrl}/mrss`,
          label: "Feed URL",
          radioLabel: "MRSS",
        },
        {
          type: "firetv",
          key: "firetvCode",
          active: true,
          getCode: () => `${this.feedUrl}/fire`,
          label: "Feed URL",
          radioLabel: "FireTv",
        },
        {
          type: "iframeVideoDeck",
          key: "iframeCodeVideoDeck",
          active: true,
          radioLabel: "Video Deck",
          blocks: [
            {
              getCode: () => this.embedIframeVideoDeck,
              label:
                "Insert this iframe where the video player should be rendered.",
            },

          ],
        }
      ],
    };
  },
  props: {
    distributionId: {
      type: String,
      required: true,
    },
    playerSettings: {
      type: Object,
      required: true,
    },
  },
  computed: {
    playerWidth() {
      const dimensions = this.playerSettings.minimumSize.split("x");
      return dimensions[0];
    },
    playerHeight() {
      const dimensions = this.playerSettings.minimumSize.split("x");
      return dimensions[1];
    },

    codeConfigActives() {
      return this.codeConfigs.filter((config) => config.active);
    },
    embedIframeVideoDeck() {
      return `
        <script>
        (function(){
          function init(){
            var iframe=document.querySelector(".videodeck");
            if(!iframe)return;
            var o=null;
            try{var s=iframe.getAttribute("src");if(s)o=new URL(s,location.href).origin;}catch(e){}
            function send(){if(!o||!iframe.contentWindow)return;try{iframe.contentWindow.postMessage({type:"parent-url",url:location.href},o)}catch(e){}}
            iframe.addEventListener("load",send);
            window.addEventListener("message",function(e){if(e.data?.type!=="request-parent-url"||e.origin!==o||e.source!==iframe.contentWindow)return;send()});
            setTimeout(send,100);
          }
          document.readyState==="loading"?document.addEventListener("DOMContentLoaded",init):init();
        })();
      </scr` + `ipt>
      <style>
        body {
          background-color: #000 !important;
        }
        .videodeck-container {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 90vw;
          height: 75vh;
        }
        .videodeck {
          display: block;
          margin: 0 auto;
          width: 100%;
          height: 100%;
        }
      </style>
      <div class="videodeck-container">
        <iframe src="${this.videoDeckPlayerUrl}/${this.distributionId}"
          class="videodeck"
          frameborder="0"
          allowfullscreen
          allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          referrerpolicy="origin"
          />
      </div>
      `;
    },

    contentDistributionId() {
      return `content-${this.distributionId}`;
    },
    feedUrl() {
      return `https://${this.feedBase}/d/${this.distributionId}`;
    },
    videoDeckPlayerUrl() {
      return process.env.VIDEO_DECK_PLAYER_URL;
    },
  },
  methods: {
    copiedToClipBoard() {
      this.$emit("copiedToClipBoard");
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.md-headline {
  margin-bottom: 10px;
}
.md-caption {
  margin-top: 5px;
}
.video-frame {
  position: relative;
}
.link-wrapper {
  margin-bottom: 15px;
  width: 100%;
  pre {
    margin-top: 0;
    margin-bottom: 15px;
    @media (max-width: 680px) {
      overflow-x: scroll;
    }
    code {
      padding: 2px 4px;
      border-radius: 4px;
      font-size: 12px;
      line-height: 1.5;
      font-family: monospace;
    }
  }
  .code-label {
    margin: 0;
    color: rgba(0, 0, 0, 0.54);
    font-size: 14px;
  }
  .copy {
    margin-top: -10px;
    width: 35px;
    min-width: 35px;
    height: 30px;
    .md-icon {
      font-size: 20px;
    }
  }
}
#code-examples {
  padding-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/shared-components/video/VideoPreview.vue